import React from 'react';
import { RadarChart as eRadarChart } from 'echarts/charts';
import {
  GridComponent,
  LegendComponent,
  MarkLineComponent,
  TitleComponent,
  TooltipComponent,
} from 'echarts/components';
import * as echarts from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import PropTypes from 'prop-types';

import { ITPMETRICS_GREEN, ITPMETRICS_PURPLE, ITPMETRICS_YELLOW } from '../common/Colours';

echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  eRadarChart,
  CanvasRenderer,
  LegendComponent,
  MarkLineComponent,
]);

export function ReportPersonaltySpiderChart({ scores, teamScores }) {
  if (!teamScores.Agreeableness) {
    return null;
  }

  const selfRatingScores = [
    scores.Agreeableness || 'N/A',
    scores.Conscientiousness || 'N/A',
    scores.Emotionality || 'N/A',
    scores.Extraversion || 'N/A',
    scores['Openness to Experience'] || 'N/A',
  ];

  const teamRatingScores = (teamScores.Agreeableness || []).map((_, index) => ([
    teamScores.Agreeableness[index],
    teamScores.Conscientiousness[index],
    teamScores.Emotionality[index],
    teamScores.Extraversion[index],
    teamScores['Openness to Experience'][index],
  ]));

  const indicator = [
    { name: 'Agreeableness', max: 100 },
    { name: 'Conscientiousness', max: 100 },
    { name: 'Emotionality', max: 100 },
    { name: 'Extraversion', max: 100 },
    { name: 'Openness to Experience', max: 100 },
  ];

  const getOption = () => ({
    tooltip: {
      trigger: 'item',
      padding: [7, 10],
      backgroundColor: 'white',
      borderColor: 'gray-300',
      textStyle: { color: 'gray-1100' },
      borderWidth: 1,
      transitionDuration: 0,
      axisPointer: {
        type: 'none',
      },
    },
    radar: {
      indicator,
      radius: 200,
      splitNumber: 10,
      splitLine: {
        lineStyle: {
          color: '#B0B0B0',
        },
      },
      axisName: {
        color: 'black',
        fontSize: 14,
      },
    },
    series: [
      {
        type: 'radar',
        data: [
          {
            value: [50, 50, 50, 50, 50],
            name: 'Population',
            lineStyle: { type: 'dashed' },
            itemStyle: {
              color: ITPMETRICS_PURPLE,
            },
          },
          ...teamRatingScores.map((values) => ({
            value: values,
            name: 'Team Mate',
            lineStyle: { opacity: 0 },
            itemStyle: {
              color: ITPMETRICS_GREEN,
            },
          })),
          {
            value: selfRatingScores,
            name: 'Self',
            itemStyle: {
              color: ITPMETRICS_YELLOW,
            },
          },

        ],
      },
    ],
  });
  return (
    <ReactEChartsCore
      echarts={echarts}
      option={getOption()}
      style={{ height: '500px', width: '750px' }}
    />
  );
}

ReportPersonaltySpiderChart.propTypes = {
  scores: PropTypes.object,
  teamScores: PropTypes.object,
};

ReportPersonaltySpiderChart.defaultProps = {
  scores: {},
  teamScores: {},
};
